import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'screens-summary';

export const { focus, update, remove, resolve, reject, patterns } =
  createLifecycleFor(TYPE);
